import { Project } from "../../../../../types";

export const getClosedProjects = (projects: Project[]) =>
  projects.filter((project) => project.closed);